export default __webpack_public_path__ + "static/media/element_20.0092c2d6.jpg";